// extracted by mini-css-extract-plugin
export default {"title":"export-dashboard-card_title__MCkKA","content":"export-dashboard-card_content__Yr7fs"};